import { useCallback, useEffect, useState } from "react";
import { newsService } from "../../../services/news.service";

export const useNewsAdmin = (
  page = 1,
  limit = 10,
  filters = {}
) => {
  const [news, setNews] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchNews = useCallback(async () => {
    try {
      setLoading(true);

      const res = await newsService.getNews({
        page,
        limit,
        ...filters,
      });

      setNews(res.data.data || []);
      setPagination(res.data.pagination || {});
    } catch (error) {
      console.error("Fetch Admin News Error:", error);
    } finally {
      setLoading(false);
    }
  }, [page, limit, filters]);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  const deleteNews = async (id) => {
    try {
      await newsService.deleteNews(id);

      await fetchNews();

      return true;
    } catch (error) {
      console.error("Delete News Error:", error);
      return false;
    }
  };

  return {
    news,
    loading,
    pagination,
    refetch: fetchNews,
    deleteNews,
  };
};